const dayjs = require('dayjs')

export const handleTimeFormat = (date) => {
	if (!date) return ''

	return dayjs(date).format('HH:mm')
}
